module.exports = __webpack_public_path__ + "img/woyaoyou_bg_login_2x.fafb2e1b.png";